module.exports = __webpack_public_path__ + "media/tekken.1f531e02.webm";